<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Seminaire" />
            <Seminaire />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import Seminaire from '../Seminaire/Seminaire.vue'

export default {
    name: 'SeminairePage',
    components: {
        NavBar,
        PageTitle,
        Seminaire,
        FooterComp,
    }
}
</script>